import WrapperLazyLoad from './WrapperLazyLoad';
import { TWrapperLazyLoadProps } from './WrapperLazyLoad.types';

export type { TWrapperLazyLoadProps };
export default WrapperLazyLoad;
